/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, Input, computed, effect, signal} from '@angular/core';
import * as _ from 'lodash';
import {SiteGroupApiService} from '../../site-group/site-group-api.service';

import {TARGETING_IMPORTS} from '../targeting-imports';

@Component({
  imports: TARGETING_IMPORTS,
  selector: 'adn-targeting-site-group-target-summary',
  template: '<strong *ngIf="negated()">NOT:&nbsp;</strong>{{siteGroups()}}',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SiteGroupSummaryComponent {
  @Input() set targets(value: any) { this.targetsInput.set(value); }

  readonly siteGroups = signal('');
  readonly negated = computed(() => !!this.targetsInput()?.negated);
  private readonly targetsInput = signal<any>(undefined);
  private cache: Record<string, string> = {};

  constructor(private readonly siteGroupApi: SiteGroupApiService) {
    effect((onCleanup) => {
      const target = this.targetsInput() || {};
      if (_.get(target, 'siteGroups[0].name')) {
        this.siteGroups.set(_.map(target.siteGroups, 'name').join(', '));
        return;
      }
      const siteGroupIds = _.get(target, 'siteGroups[0].id') ? _.map(target.siteGroups, 'id') : target.siteGroups || [];
      const queryIds = _.without(siteGroupIds, ...Object.keys(this.cache));
      if (queryIds.length === 0) {
        this.siteGroups.set(_.map(siteGroupIds, (id) => this.cache[id]).join(', '));
        return;
      }
      const subscription = this.siteGroupApi.listByIds(queryIds).subscribe((page) => {
        _.forEach(page.results, (s) => {
          this.cache[s.id] = s.name;
        });
        this.siteGroups.set(_.map(siteGroupIds, (id) => this.cache[id]).join(', '));
      });
      onCleanup(() => subscription.unsubscribe());
    });
  }
}
